import moment from 'moment';
import { DATA_LOADING_STATES } from '@config/Consts';

const setMetric = (state, data) => {
  if (data) {
    state.metrics[data.metricName] = data.value;
  }
};
const setMetricDataLoading = (state, data) => {
  if (data) {
    state.metricsDataLoading[data.metricName] = data.loadingStatus;
    if (data.loadingStatus === DATA_LOADING_STATES.SUCCESS) {
      state.lastTimeDataUpdated[data.metricName] = moment();
    }
  }
};
const setFirstTimeLoading = (state, value) => {
  state.firstTimeLoading = value;
};

export default {
  setMetricDataLoading,
  setFirstTimeLoading,
  setMetric,
};
